import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useBranding } from "../branding/BrandingContext";

const aktuellesJahr = new Date().getFullYear();

function Footer() {
  const { t } = useTranslation();
  const { branding } = useBranding();
  const isWhitelabel = !!branding?.slug;
  const appName = branding?.app_name || "DATA optimizer";

  return (
    <footer>
        <p className="form-subtext"><Link to="/terms-of-use">{t("footer.terms")}</Link>  |  <Link to="/datenschutz">{t("footer.dataProtection")}</Link>  |  <Link to="/imprint">{t("footer.legalNotice")}</Link></p>
        <p className="form-subtext">
          <Trans
            i18nKey={isWhitelabel ? "footer.brandLineWhitelabel" : "footer.brandLine"}
            values={{ year: aktuellesJahr, appName }}
            components={{ brand: <strong /> }}
          />
        </p>
    </footer>
  );
}

export default Footer;